export const API_ENDPOINTS = {
  // Authentication endpoints
  AUTH: {
    LOGIN: '/auth/login',
    REGISTER: '/auth/register',
    VERIFY_TOKEN: '/auth/verify-token',
    LOGOUT: '/users/logout',
    REFRESH: '/auth/refresh',
  },

  // Job endpoints
  JOBS: {
    LIST: '/jobs/',
    CREATE: '/jobs/',
    GET: '/jobs',
    UPDATE: '/jobs',
    DELETE: '/jobs',
    UPDATE_STATUS: '/jobs/update-status',
    STATUS_LIST: '/jobs/getstatuslist',
    GET_BY_USER_EMAIL: '/jobs/getjobs',
    ASSIGN_SME: '/jobs/assignsme',
  },

  // Resume endpoints
  RESUMES: {
    LIST: '/resumes/',
    CREATE: '/resumes/',
    GET: '/resumes',
    UPDATE: '/resumes',
    DELETE: '/resumes',
    UPDATE_STATUS: '/resumes/update-status',
    BULK_UPLOAD: '/resumes/bulk-upload',
    BULK_UPLOAD_STATUS: '/resumes/bulk-upload/status',
    DOWNLOAD: '/resumes/download',
    PREVIEW: '/resumes/preview',
    ASSIGN_PANEL: '/resumes/panel/assign',
  },

  // User endpoints
  USERS: {
    LIST: '/users/',
    ME: '/users/me',
    UPDATE_ME: '/users/me',
    GET_BY_USERNAME: '/users',
    LOGOUT: '/users/logout',
  },

  // Voice Services
  VOICE: {
    VOICE_TO_TEXT: '/voice/voice-to-text',
    TEXT_TO_VOICE: '/voice/text-to-voice',
    CHAT: '/voice/chat',
    VOICE_CHAT: '/voice/voice-chat',
    START_CONVERSATION: '/voice/conversation/start',
    CLEAR_CONVERSATION: '/voice/conversation/clear',
    LANGFLOW_MESSAGE: '/voice/langflow/message',
    LANGFLOW_HEALTH: '/voice/langflow/health',
  },

  // Admin Operations
  ADMIN: {
    REGISTER: '/admin/register',
    DELETE_USER: '/admin/delete',
    UPDATE_USERS: '/admin/update-users',
    GET_ALL_USERS: '/admin/users',
  },

  // Health endpoints
  HEALTH: {
    USER_SERVICE: '/health/user-service',
    JOB_APPLICATION_SERVICE: '/health/job-application-service',
    VOICE_SERVICE: '/health/voice-service',
    AUTH_SERVICE: '/health/auth-service',
  },

  // Reports endpoints
  REPORTS: {
    HR: '/reports/hr',
    AUDIT_TRACKER: '/reports/audit-tracker',
    PANELISTS: '/reports/panelists',
    AUDIT_TRACKER_EXCEL_JSON: '/reports/audit-tracker/excel-json',
    DOWNLOAD_FILE: '/reports/download-file',
  },
} as const;

export default API_ENDPOINTS;
